import emojiData from './emoji.json'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import mitt from 'mitt';

const emojiUrl = "https://cdn.jsdelivr.net/npm/twemoji@11.3.0/2/svg/";

export function isEmoji(content) {
    return emojiData?.filter((item) => (':' + item.key == content))?.length > 0
}

export function getEmojiUrl(content) {
    var emoji
    for (var i = 0; i < emojiData.length; i++) {
        if (':' + emojiData[i].key == content) {
            emoji = emojiData[i]
        }
    }
    if (emoji) {
        return emojiUrl + emoji.value + ".svg"
    }
    return content
}

export function formatTimeYDM(timestamp) {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    const formatted = dayjs(timestamp)
        .tz('Asia/Shanghai')
        .format('YYYYMMDD');
    return formatted;
}

/*
使用案例
const url = fillTemplate(
  "http://record.olacio.com/record/data/media/{roomId}/{name}?date={date}",
  {
    roomId: '123456',
    name: 'video.mp4',
    date: '2025-06-19',
  }
);
*/
export function fillTemplate(str, data) {
    return str.replace(/{(\w+)}/g, (_, key) => data[key] ?? '');
}

export const emitter = mitt();
